// Add theme as per your requirement

export const dark = {
    body:"#202020", //black shade,
    text :"#fff",
    bodyRgba:'32,32,32',
    textRgba:'255,255,255',

    gray:'#bebebe',//gray shade

    fontxs:'0.75em',
    fontsm:'0.875em',
    fontmd:'1em',
    fontlg:'1.25em',
    fontxl:'2em',
    fontxxl:'3em',
    fontxxxl:'5em',
    fontBig:'10em',

    navHeight:'5rem',
}
